import { Platform, StyleSheet } from 'react-native';

export default StyleSheet.create({
  titleContainerStyle: withRightView => ({
    ...Platform.select({
      android: {
        marginTop: withRightView ? -3 : 18,
      },
      ios: {
        marginTop: withRightView ? -7 : 27,
      },
    }),
    paddingHorizontal: 16,
    marginBottom: withRightView ? -14 : 0,
  }),
});
